import {createLogger} from "../util/logger";
import {AjaxPagination} from "./AjaxPagination";
import {filterEventSelector, once} from "../util/event";
import {getParent} from "../util/dom";
import {createElement} from "../util/html";
import gsap, {Power3} from "gsap";
import {ScrollAnimations} from "./ScrollAnimations";
import {fetchPage} from "../util/ajax";
import {AjaxNavigation} from "./AjaxNavigation";
import {Toast} from "./Toast";
const console = createLogger("NewsPage");

export class NewsPage extends AjaxPagination {
    static name = "news-page";

    overlayTweenDefaults = {
        duration: 0.5,
        ease: Power3.easeOut,
    };

    get name() {
        return NewsPage.name;
    }

    constructor(el) {
        super(el);

        /**
         * Original page url
         * s
         * @type {string}
         */
        this.originalUrl = window.location.href;

        /**
         *
         * @type {HTMLFormElement}
         */
        this.$form = this.$("form");

        /**
         * @type {HTMLElement}
         */
        this.$overlay = this.$("overlay");

        /**
         * @type {HTMLElement}
         */
        this.$overlayContent = this.$("overlayContent");


        this.addEventListener(this.$form, "submit", this.onSubmitForm.bind(this));

        this.addEventListener(this.el, "submit",
            filterEventSelector(this.getAttributeSelector("pinForm"), this.onSubmitPin.bind(this))
        );

        this.addEventListener(this.$overlay, "click", filterEventSelector(".page-overlay__close", this.onClickCloseOverlay.bind(this)));

        this.addEventListener(this.el, "click", filterEventSelector(`${this.getAttributeSelector("post")} a`, this.onClickNewsPost.bind(this)));

        this.addEventListener(window, "popstate", (e) => {
            if (this.overlayVisible) {
                this.hideOverlay();
            }
        });

        if (window.location.hash) {
            const url = window.location.hash.slice(1);
            console.log(url);
            this.viewPost(window.location.origin + window.location.hash.slice(1));
        }

        console.log(this);

    }

    /**
     *
     * @param {SubmitEvent} e
     */
    onSubmitPin(e) {
        e.preventDefault();
        console.log("onSubmitPin");

        const data = new FormData(e.target);


        fetch(e.target.getAttribute("action"), {
            method: "POST",
            body: data,
        }).then((res) => res.json()).then(res => {
            Toast.showToast(res.message, res.pinned ? "success" : "warning", 3000);

            // Replace elements with response html
            Object.keys(res.html || {}).forEach((selector) => {
                const el = this.querySelectorAll(selector);
                if (!el) return;

                let newEl = createElement(res.html[selector]);
                newEl = newEl.querySelector(selector) || newEl
                console.log("replace", el, newEl);

                el.forEach(el => el.replaceWith(newEl.cloneNode(true)));
            });
        });
    }

    /**
     * Submit handler for search form
     *
     * @param {SubmitEvent} e
     */
    onSubmitForm(e) {
        e.preventDefault();
        const data = new FormData(e.currentTarget);

        const url = new URL(e.currentTarget.action);
        url.search = (new URLSearchParams(data)).toString();

        window.history.pushState(null, "", url);
        this.isReplace = true;
        this.loadPage(url, true).then(() => this.isReplace = false);
    }


    /**
     * Handles click on event details link
     * @param {MouseEvent} e
     */
    onClickNewsPost(e) {
        e.preventDefault();
        e.stopPropagation();

        const url = getParent(e.target, "a")?.getAttribute("href");

        console.log("onClickNewsPost", url);

        this.viewPost(url);
    }

    /**
     * Click event handler for overlay  close button
     * @param {MouseEvent} e
     */
    onClickCloseOverlay(e) {
        console.log("onClickCloseOverlay");
        e.preventDefault();
        e.stopPropagation();

        AjaxNavigation.instance.disable();

        once(window, "popstate", () => {
            AjaxNavigation.instance.enable();
        });

        window.history.back();

        this.hideOverlay();
    }

    /**
     * Loads post via ajax and displays it
     * @param url
     */
    viewPost(url) {
        if (!url?.length) return;

        window.history.pushState(null, "", url);
        fetchPage(url).then((html) => {
            const content = html.querySelector(".site-wrapper");

            this.$overlayContent.replaceChildren(content);

            this.showOverlay();
        });
    }

    /**
     * Shows overlay
     */
    showOverlay() {
        this.overlayVisible = true;
        gsap.set(document.body, {overflow: "hidden"});

        const tl = gsap.timeline();
        tl.to(this.$overlay, {
            ...this.overlayTweenDefaults,
            top: "-=100%",
            opacity: 1,
            onComplete: () => {
            }
        });
        tl.add(() => {
            console.log("triggerScrollAnimations");
            ScrollAnimations.updateAnimations(this.$overlayContent);
        }, "-=0.3");
    }

    /**
     * Hides overlay
     */
    hideOverlay() {
        this.overlayVisible = false;
        gsap.set(document.body, {overflow: ""});
        gsap.to(this.$overlay, {
            ...this.overlayTweenDefaults,
            top: "+=100%",
            opacity: 0,
        });
    }
}
